import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizForm } = component_tool
const { WizContainer } = framework_tool
const { isType } = utils_tool
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'
const positionConfig = WizTableForm.Config.positionName(this, { apiParams: { state: 1 } })

class Editor extends WizContainer {
  componentName = 'Editor'

  constructor(props) {
    super(props)
    this.state = {
      timestamp: new Date().getTime()
    }
  }

  _ok = (data) => {
    this.doAction({
      path: 'syncRelation/save',
      payload: {
        key: 'syncRelation@save',
        apiParams: data
      }
    })
  }


  propsAndStateOnChange = {
    save: this._saveOnChange.bind(this)
  }

  _saveOnChange(nextProps, nextState) {
    if (nextProps.save.code === 1) {
      wizNotice.success('操作成功')
      this.props.changeModal(false, true);
      let { editorSuccess } = this.props
      editorSuccess && editorSuccess()
    } else {
      wizNotice.error(nextProps.save.msg)
    }
  }


  render() {
    const { record = {} } = this.props
    if (['SyncNewEnergyPosition', 'SyncPosition'].indexOf(record.dataType) !== -1) {
      record.lmsId = parseInt(record.lmsId)
    }

    const columns = [
      {
        name: 'id',
        dataIndex: 'id',
        formItem: {
          type: 'hidden'
        }
      },
      {
        title: '来源',
        name: 'channel',
        dataIndex: 'channel',
        formItem: {
          disabled: !!record.id,
          initialValue: record.channel,
          type: 'select',
          rules: [{ required: true, message: '请选择来源' }],
        },
        dict: [
          {code: 'Zk', codeName: '企业号'}
        ]
      },
      {
        title: "关联类型",
        name: "dataType",
        dataIndex: "dataType",
        formItem: {
          disabled: !!record.id,
          type: 'select',
          rules: [{ required: true, message: '请选择关联类型' }],
        },
        dict: [
          {code: 'SyncPosition', codeName: '普通岗位'},
          {code: 'SyncNewEnergyPosition', codeName: '新能源岗位'},
        ]
      },
      {
        title: "第三方岗位编码",
        name: "thirdId",
        dataIndex: "thirdId",
        formItem: {
          rules: [{ required: true, message: '请输入第三方岗位编码' }],
        },
      },
      record.id ? {
        title: "岗位所属组织变更",
        name: "markOrgId",
        dataIndex: "markOrgId",
        dict: record?.positionOrgList?.filter(item => item.id !== 1106)?.map(item => {return {code: item.id, codeName: item.name}}) || [],
        formItem: {
          type: 'select',
          rules: [{ required: true, message: '请选择岗位所属组织变更' }],
        },
      } : {},
      {
        title: '岗位',
        name: 'lmsId',
        dataIndex: 'lmsId',
        formItem: {
          ...positionConfig,
          initRows: record ? [{ id: record?.positionId, name: record?.positionName }] : [],
          diy: WizTableForm,
          selectType: 'radio',
          placeholder: '请选择岗位',

          onChangeRowMap: data => {
            if (data && isType(data, 'Object')) {
              for (let [key, value = {}] of Object.entries(data)) {
                let {
                  code = '',
                  orgList = '',
                } = value
                this.refs.form && this.refs.form.setFieldsValue({
                  positionCode: code,
                  positionOrgList: orgList,
                })
              }
            }
          },
          rules: [{ required: true, message: '请选择岗位' }],
        }
      },
      {
        title: '岗位编码',
        name: 'positionCode',
        dataIndex: 'positionCode',
        formItem: {
          type: 'diy',
          links: 'positionCode',
          diy: ({ linksValues }) => {
            return linksValues || record?.positionCode || <span/>;
          }
        }
      },
      {
        title: '所属组织',
        name: 'positionOrgList',
        dataIndex: 'positionOrgList',
        formItem: {
          type: 'diy',
          links: 'positionOrgList',
          diy: ({ linksValues }) => {
            return (linksValues || record?.positionOrgList)?.map(item => item?.name)?.join(',') || <span/>;
          },
        }
      },
    ]

    const formProps = {
      key: record.id || this.state.timestamp,
      ref: 'form',
      columns,
      record,
      preview: false,
      onSubmit: this._ok,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      }
    }

    return <WizForm {...formProps} />
  }
}
const mapStateToProps = (state, ownProps) => {
  const { syncRelation } = state
  const save = modelUtils.getModelEntity(syncRelation, 'syncRelation@save')
  return {
    save
  }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(Editor)
